export const inspectTable_1 = [
  {
    content: "중량물 취급 작업계획서*를 작성하고, 작업지휘자를 지정하여 작업계획서에 따라 작업을 지휘하도록 조치한다.<br/>*추락·낙하·전도·협착·붕괴위험 예방대책",
    isChecked: "",
    title: "중량물",
  },
  {
    content: "비·눈·바람 또는 그 밖의 기상상태가 불안정한 경우 중량물 인양 작업을 중지한다.",
    isChecked: "",
    title: "중량물",
  },
  {
    content: "중량물 인양작업 구간은 미리 작업자의 출입을 통제하여 인양중인 화물이 작업자의 머리 위로 통과하지 않도록 조치한다.",
    isChecked: "",
    title: "중량물",
  },
  {
    content: "양중기로 철근을 운반할 경우에는 두 군데 이상 묶어서 수평으로 운반한다.",
    isChecked: "",
    title: "중량물",
  },
  {
    content: "와이어로프 등이 훅으로부터 벗겨지는 것을 방지하기 위한 훅 해지장치의 설치여부를 확인한다",
    isChecked: "",
    title: "슬링·훅",
  },
  {
    content: "달기구의 최대 허용하중 등의 표식이 견고하게 붙어 있는 것을 사용한다.",
    isChecked: "",
    title: "슬링·훅",
  },
  {
    content: "와이어로프·달기체인·섬유로프·슬링벨트, 훅·샤클·링 등의 철구의 손상여부를 작업 전, 작업 중에 수시로 확인한다.",
    isChecked: "",
    title: "슬링·훅",
  },
  {
    content: "변형되어 있는 훅·샤클·클램프 및 링 등의 철구로서 변형되어 있는 것 또는 균열이 있는 것을 크레인 및 이동식크레인의 고리걸이용구로 사용하지 않는다.",
    isChecked: "",
    title: "슬링·훅",
  },
  {
    content: "중량물을 운반하기 위해 제작하는 지그, 훅의 구조를 운반 중 주변 구조물과의 충돌로 슬링이 이탈되지 않도록 하여야 한다.",
    isChecked: "",
    title: "슬링·훅",
  },
  {
    content: "늘어난 달기체인이나 꼬임이 끊어진 섬유로프의 사용을 금지한다.",
    isChecked: "",
    title: "슬링·훅",
  },
];

export const inspectTable_2 = [
  {
    content: "물체가 떨어지거나 날아올 위험이 있는 장소의 모든 작업자에게 안전모, 안전화를 지급하고 착용하도록 한다.",
    isChecked: "",
    title: "보호구 지급",
  },
  {
    content: "낙하물방지망을 설치하는 경우 높이 10미터 이내마다, 내민 길이는 벽면으로부터 2m 이상으로 설치하고, 수평면과의 각도는 20도 이상 30도 이하를 유지한다.",
    isChecked: "",
    title: "낙하물 방지망 등",
  },
  {
    content: "낙하물방지망 및 수직보호망은「산업표준화법」에 따른 한국산업표준에서 정하는 성능기준에 적합한 것을 사용한다.",
    isChecked: "",
    title: "낙하물 방지망 등",
  },
  {
    content: "외부 비계와 외벽의 틈에 낙하물 방지망(쪽망)을 설치하여 비계와 외벽의 틈새로 낙하물이 떨어지는 것을 방지한다.",
    isChecked: "",
    title: "낙하물 방지망 등",
  },
  {
    content: "외부 비계는 수직보호망을 촘촘히 설치하여 부품, 자재 등의 낙하를 방지한다.",
    isChecked: "",
    title: "낙하물 방지망 등",
  },
  {
    content: "작업현장 내 통로, 출입구 등 작업자가 통행하는 구간에 방호선반을 설치한다.",
    isChecked: "",
    title: "낙하물 방지망 등",
  },
  {
    content: "슬라브 단부, 개구부에 안전난간을 설치하는 경우 발끝막이판은 바닥면 등으로부터 10센티미터 이상의 높이를 유지하거나, 난간에 수직보호망을 설치하여 낙하물을 방지한다.",
    isChecked: "",
    title: "발끝막이판",
  },
  {
    content: "슬라브의 단부, 개구부 주변, 비계 등에 자재, 부품 등을 쌓아두지 않는다.",
    isChecked: "",
    title: "기타",
  },
];
